import { ProductPurchaseModel } from 'api-hooks/product/order';
import { ChevronDown } from 'baseui/icon';
import { XCircleSVG } from 'common/assets';
import { string2money } from 'common/utils/string';
import { Form, FormState, Input } from 'components/elements';
import { Button, IconButton } from 'components/elements/buttons';
import Text from 'components/elements/text';
import useDrawer from 'hooks/use-drawer';
import { SeparatorHorizontal } from 'legacy-modules/styles';
import useTranslation from 'next-translate/useTranslation';
import * as React from 'react';
import { useFormContext } from 'react-hook-form';

import SummaryDrawer from './summary-drawer';
import useRecalculate from '../../hooks/use-recalculate';
import {
  SummaryContent,
  SummaryLeftContainer,
  SummaryRightContainer,
} from '../styles';

interface Props {
  productPurchase?: ProductPurchaseModel;
}

export default function BottomSection(props: Props) {
  const { productPurchase } = props;
  const { t } = useTranslation();
  const drawer = useDrawer();

  const methods = useFormContext<ProductPurchaseModel>();
  const { clearErrors, reset } = methods;

  const { total } = useRecalculate();

  const onOpenSummaries = React.useCallback(() => {
    drawer.showCustom({
      backdropClose: true,
      render(close) {
        return (
          <Form methods={methods} onSubmit={() => {}}>
            <SummaryDrawer onClose={close} />
          </Form>
        );
      },
    });
  }, [drawer, methods]);

  return (
    <SummaryContent>
      <SummaryLeftContainer>
        <Text variant={{ initial: 'LabelSmall', md: 'LabelLarge' }}>
          {t('common:total_order')}:
        </Text>
        <SeparatorHorizontal $margin={16} />
        <Text
          variant={{ initial: 'HeadingXSmall', md: 'HeadingSmall' }}
        >{`Rp. ${string2money(total)}`}</Text>
        <SeparatorHorizontal $margin={16} />
        <IconButton buttonType="tertiary" onClick={onOpenSummaries}>
          <ChevronDown size={24} />
        </IconButton>
      </SummaryLeftContainer>
      <FormState>
        {({ editable, setIsEditable }) =>
          editable && (
            <SummaryRightContainer>
              {productPurchase && (
                <>
                  <Button
                    buttonType="secondary"
                    startEnhancer={(color, size) => (
                      <XCircleSVG size={size} color={color} />
                    )}
                    onClick={() => {
                      clearErrors();
                      reset();
                      setIsEditable(false);
                    }}
                    overrides={{
                      Root: {
                        style: {
                          flex: 1,
                        },
                      },
                    }}
                  >
                    {t('common:cancel')}
                  </Button>
                  <SeparatorHorizontal $margin={24} />
                </>
              )}
              <Input
                type="submit"
                overrides={{
                  Root: {
                    style: {
                      flex: 1,
                    },
                  },
                }}
              />
            </SummaryRightContainer>
          )
        }
      </FormState>
    </SummaryContent>
  );
}
